import { DocumentAttachComponent } from './document-attach/document-attach.component';
import { NgModule } from '@angular/core';
import { COMMON_IMPORTS } from 'ng2-app/common-imports';

@NgModule({
    imports: [
        COMMON_IMPORTS,
    ],
    exports: [
        DocumentAttachComponent
    ],
    declarations: [
        DocumentAttachComponent
    ],
    providers: [],
})
export class DocumentModule { }
